// extracted by mini-css-extract-plugin
export default {"fab":"mapMenu_fab__ins1U","mapSettings":"mapMenu_mapSettings__EJ45z","closeButton":"mapMenu_closeButton__NZnvU"};